/* eslint-disable */
import React, {
  useCallback, useEffect, useMemo, useRef, useState
} from 'react';
import { UseFormReturn } from 'react-hook-form';
import SignatureCanvas from 'react-signature-canvas';
import {
  Image, Loading, Typography
} from 'tfc-components';

import buttonEmpty from 'assets/images/button_empty.png';
import bgConfirm from 'assets/images/bg-confirm-remake.jpg';
import xacnhan from 'assets/images/xacnhan.png';
import Icon from 'components/atoms/Icon';
import { UserInfoType } from 'pages/UserInfo';
import { CheckinParams } from 'services/checkin/types';
import { useAppSelector } from 'store/hooks';
import mapModifiers, {
  formatDDMMYYYY,
  imageLoader, wrapText
} from 'utils/functions';

type ConfirmProps = {
  checkinMethod: UseFormReturn<UserInfoType>;
  handleSubmit: (data: CheckinParams) => void;
  isCheckin?: boolean;
  loading?: boolean;
};

const WIDTH = 1600;
const HEIGHT = 2134;
const TEXT_SIZE = 29;
const TEXT_SIZE_NAME = 34;
const TEXT_COLOR = '#fff';

const Confirm: React.FC<ConfirmProps> = ({
  handleSubmit, checkinMethod, isCheckin, loading
}) => {
  const [signature, setSignature] = useState<SignatureCanvas>();
  const [url, setUrl] = useState<string>('');
  const [confirmJoin, setConfirmJoin] = useState<boolean>(true);
  const [firstTime, setFirstTime] = useState<boolean>(false);
  const [isSigned, setIsSigned] = useState<boolean>(false);
  const campaign = useAppSelector((state) => state.system.campaignData);

  const backgroundRef = useRef<HTMLImageElement | null>(null);
  const canvas = useMemo(() => {
    const c = document.createElement('canvas');
    c.width = WIDTH;
    c.height = HEIGHT;

    return c;
  }, []);
  const onhandleSubmit = () => {
    if (!confirmJoin || !isSigned) {
      setFirstTime(true);
      return;
    }
    canvas.toBlob(async (blob) => {
      if (blob) {
        const file = new File([blob], 'confirm.jpeg');
        // setImg(URL.createObjectURL(file));
        const submitData = checkinMethod.getValues();
        handleSubmit({
          invitation_code: submitData.invitation_code || '',
          phone: submitData.phone,
          full_name: submitData.full_name,
          position_or_degree: submitData.position_or_degree,
          hospital: submitData.hospital,
          department: submitData.department,
          provinceCode: submitData.provinceCode?.value,
          dob: submitData.dob ? formatDDMMYYYY(submitData.dob) : undefined,
          signature: file,
        });
      }
    }, 'image/jpeg');
  };

  const handleClearSignature = () => {
    setIsSigned(false);
    signature?.clear();
    setUrl('');
  };

  const handleEndSignature = () => {
    setIsSigned(true);
    setUrl(signature?.getTrimmedCanvas().toDataURL('image/png') || '');
  };

  const ctx = useMemo(() => canvas.getContext('2d')!, [canvas]);

  const draw = useCallback(async () => {
    if (!campaign) {
      return;
    }
    if (!backgroundRef.current) {
      const bg = await imageLoader(bgConfirm);
      backgroundRef.current = bg;
      ctx.drawImage(bg, 0, 0, WIDTH, HEIGHT);
    } else {
      ctx.drawImage(backgroundRef.current, 0, 0, WIDTH, HEIGHT);
    }

    ctx.font = `bold ${TEXT_SIZE}px 'Open Sans', sans-serif`;

    ctx.fillStyle = TEXT_COLOR;
    const title = campaign?.seminarTitle?.split('<br />');
    title.forEach((item: string, index: number) => {
      const textWidth = ctx.measureText(item).width;
      ctx.fillText(item.toUpperCase(), WIDTH / 2 - textWidth / 2, 490 + index * 50);
    });

    /// /// Draw time and location
    const timeText = `Thời gian: ${campaign?.startAt}`;
    const locationText = `Địa điểm: ${campaign?.address?.toUpperCase()}`;
    ctx.fillText(timeText, WIDTH / 2 - (ctx.measureText(timeText).width) / 2, 660);
    ctx.fillText(locationText, WIDTH / 2 - (ctx.measureText(locationText).width) / 2, 715);

    ctx.font = `bold ${TEXT_SIZE_NAME}px 'Open Sans', sans-serif`;

    ctx.fillText((checkinMethod.getValues('full_name') || '').toUpperCase(), 460, 802);
    const wrappedText = wrapText(ctx, (checkinMethod.getValues('hospital') || '').toUpperCase(), 462, 865, WIDTH - 630, 56);
    wrappedText.forEach((item: any) => {
      ctx.fillText(item[0], item[1], item[2]);
    });
    ctx.fillText(`TỈNH THÀNH: ${(checkinMethod.getValues('provinceCode.label') || '').toUpperCase()}`, 236, 932);

    if (url) {
      const sign = await imageLoader(url);

      ctx.drawImage(
        sign,
        sign.width > 1000 ? 290 : 290 + (1000 - sign.width) / 2,
        sign.height > 450 ? 1250 : 1250 + (450 - sign.height) / 2,
        sign.width > 1000 ? 1000 : sign.width,
        sign.height > 450 ? 450 : sign.height
      );
      // setImg(ctx.canvas.toDataURL('image/jpeg'));
    }
  }, [checkinMethod, ctx, campaign, url]);

  useEffect(() => {
    draw();
  }, [draw]);

  return (
    <div className="p-confirm">
      <div className="p-confirm_conventionTitle">
        <div className="p-confirm_title">
          <Typography.Text
            fontweight="600"
          >
            Hội nghị:
            {' '}
            <span dangerouslySetInnerHTML={{ __html: campaign?.seminarTitle || '' }} />
          </Typography.Text>
        </div>
        <Typography.Text
          extendClasses="fs-26x36"
          fontweight="600"
        >
          {`Thời gian: ${campaign?.startAt || ''}`}
        </Typography.Text>
        <Typography.Text
          extendClasses="fs-26x36"
          fontweight="600"
        >
          {`Địa điểm: ${campaign?.address || ''}`}
        </Typography.Text>
      </div>
      <div className="p-confirm_userInfo">
        <Typography.Text
          extendClasses="fs-26x36"
          fontweight="600"
        >
          HỌ VÀ TÊN:
          {' '}
          {checkinMethod.getValues('full_name') || ''}
        </Typography.Text>
        <Typography.Text
          extendClasses="fs-26x36"
          fontweight="600"
        >
          BỆNH VIỆN:
          {' '}
          {checkinMethod.getValues('hospital') || ''}
        </Typography.Text>
        <Typography.Text
          extendClasses="fs-26x36"
          fontweight="600"
        >
          TỈNH THÀNH:
          {' '}
          {checkinMethod.getValues('provinceCode')?.label || ''}
        </Typography.Text>
      </div>
      <div className="p-confirm_conditionWrapper">
        <div className="p-confirm_conditionWrap">
          <div
            className="p-confirm_condition"
            onClick={() => setConfirmJoin(!confirmJoin)}
          >
            {confirmJoin && <Icon iconName="check" size="38" />}
          </div>
          <p
            onClick={() => setConfirmJoin(!confirmJoin)}
            className="p-confirm_termsText fs-26x36 color-antiFlashWhite"
          >
            Xác nhận tham dự hội nghị.
          </p>
        </div>
        {/* <div className="p-confirm_conditionWrap">
          <div
            className="p-confirm_condition"
            onClick={() => setConfirmJoin(!confirmJoin)}
          >
            {confirmJoin && <Icon iconName="check" size="38" />}
          </div>
          <p
            onClick={() => setConfirmJoin(!confirmJoin)}
            className="p-confirm_termsText fs-26x36 color-antiFlashWhite"
          >
            Tôi xác nhận việc nhận 1 chai Prosure Vanilla 220ml và 4 gói Prosure Vanilla 37.5G
            để phân phát cho bệnh nhân dùng thử. Tôi thừa nhận rằng tôi không bị ràng buộc sử dụng,
            mua, đặt mua, giới thiệu, hoặc kê đơn bất kỳ sản phẩm nào của Abbott, hoặc dành cho
            Abbott sự ưu đãi dưới hình thức khác.
          </p>
        </div> */}
        {!confirmJoin && firstTime && (
          <Typography.Text
            extendClasses="p-confirm_termsText-error fs-18x26 u-mt-8"
            fontweight="400"
          >
            Vui lòng xác nhận để tiếp tục
          </Typography.Text>
        )}
      </div>
      <div className="p-confirm_signatureWrapper">
        <SignatureCanvas
          canvasProps={{ className: 'sigCanvas' }}
          ref={(data: any) => setSignature(data)}
          onEnd={handleEndSignature}
        />
        <div
          className="p-confirm_clear"
          onClick={handleClearSignature}
        >
          <Icon iconName="clear" size="38" />
        </div>
        {!isSigned && firstTime && (
          <Typography.Text
            extendClasses="p-confirm_termsText-error fs-18x26 u-mt-8"
            fontweight="400"
          >
            Vui lòng ký tên để tiếp tục
          </Typography.Text>
        )}
      </div>
      <div
        className={mapModifiers('p-confirm_confirmButton', loading && 'loading')}
        onClick={() => {
          if (!loading) {
            onhandleSubmit();
          }
        }}
      >
        {isCheckin && (
          <Typography.Text
            extendClasses="p-confirm_termsText-error p-confirm_termsText-checkin fs-26x36 u-mt-8"
            textStyle="center"
            fontweight="400"
          >
            Đã đăng ký tham dự chương trình
          </Typography.Text>
        )}
        <Image
          imgSrc={loading ? buttonEmpty : xacnhan}
          alt="checkBtn"
          ratio={600 / 109}
          extendClasses="p-confirm_confirmButton_img"
        />
        {loading && (
          <Loading.Circle color="#0e3878" width={36} extendClasses="p-confirm_confirmButton_indicator" />
        )}
      </div>
      {/* <img src={img} alt="preview" style={{ width: '100%', height: 'auto' }} /> */}
    </div>
  );
};

export default Confirm;
